import point from "../point";
import line from "../line";
import sqftConfig from "../../../store/sqftConfig";

const dot = function() {
  let points;
  if(sqftConfig.measureUnit === "Metric" ) {
    points = [
      new point(0, 0, "lefttop"),
      new point(23.62, 0, "righttop"),
      new point(23.62, 23.62, "rightbottom"),
      new point(0, 23.62, "leftbottom")
    ];
  } else {
    points = [
      new point(0, 0, "lefttop"),
      new point(26, 0, "righttop"),
      new point(26, 26, "rightbottom"),
      new point(0, 26, "leftbottom")
    ];
  }

  let lines = [
    new line(points[0], points[1]),
    new line(points[1], points[2]),
    new line(points[2], points[3]),
    new line(points[3], points[0])
  ];

  return lines;
};

export default dot
